import React, { useState } from 'react'
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const MyManagementDash = ({
  setselectedTabState,
  setselectedTabprojectrequest,
  setselectedTabprojectapproved,
  setselectedTabprojectassign,
  setselectedTabprojectongoing,
  setselectedTabprojectcomplete,
  selectedTabprojectrequest,
  selectedTabprojectapproved,
  selectedTabprojectassign,
  selectedTabprojectongoing,
  selectedTabprojectcomplete,
  unreadcount,
  unreadcountapproved,
  unreadcountAssign,
  unreadcountongoing,
  unreadcountcomplete,
  projectsRequest,
  approvedProjectsManager,
  assignedOpProjects,
  ongoingOpProjects,
  completeOpProjects
}) => {
  const [hoveredAssignmentBucket, setHoveredAssignmentBucket] = useState("");

  const assignmentHoverTextMap = {
    projectRequest:
      "Project Name - Forward/Reject Project - Assign Tasks to Employees and Self - Fill the Task Details - Complete the self or other submitted response",
    projectApproved: "Project Name - View Details",
    projectAssigned:
      "Project Name - View Details - Assign task to Employees - Submit the task for Self and Others - complete each response - Submit the final project",
    projectOngoing:
      "Project Name - View Details - Fill the data for Self and Others - Mark task as complete - Submit the project",
    projectCompleted: "Project Name - View Details",
  };


  return (
    <div className="bg-white rounded-md h-auto">
      <div className="bg-white rounded-md h-auto">
        <div className=" relative">
          <div className="">
            <div className="relative pt-3">
              <div>
                <div className="">
                  <div className="relative bg-[#e8e8e8] border border-gray-400 text-center mx-2 p-2 rounded-t-lg font-semibold">
                    My Requests
                  </div>
                  <div className="flex w-full pt-5 p-2">
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[450px] w-[20%] items-center"
                      onMouseEnter={() => setHoveredAssignmentBucket("projectRequest")}
                      onMouseLeave={() => setHoveredAssignmentBucket("")}
                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Requests
                        </p>
                      </div>
                      <div
                        onClick={() => {
                          setselectedTabState("projectRequest")
                          setselectedTabprojectrequest(!selectedTabprojectrequest)
                          setselectedTabprojectapproved(false)
                          setselectedTabprojectassign(false)
                          setselectedTabprojectongoing(false)
                          setselectedTabprojectcomplete(false)
                        }}

                        className={`relative flex ${selectedTabprojectrequest
                          ? "bg-blue-900 border-[#3a1e0a] shadow-lg"
                          : "bg-[#4e95d9] border-[#5A3D2B]"
                          } border-[#5A3D2B] items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer 
                          
                          `}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadcount.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">

                            <span

                              className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                            >
                              {unreadcount.length}
                            </span>
                          </div>
                        )}



                        <span className={`text-white ${unreadcount.length > 0 ? "text-2xl font-semibold" : "text-lg"} font-semibold`}>
                          {projectsRequest.length}
                        </span>
                        {selectedTabprojectrequest && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[450px] w-[20%] items-center"
                      onMouseEnter={() => setHoveredAssignmentBucket("projectApproved")}
                      onMouseLeave={() => setHoveredAssignmentBucket("")}
                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Approved
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          setselectedTabState("projectApproved")
                          setselectedTabprojectrequest(false)
                          setselectedTabprojectapproved(!selectedTabprojectapproved)
                          setselectedTabprojectassign(false)
                          setselectedTabprojectongoing(false)
                          setselectedTabprojectcomplete(false)
                        }}
                        
                        className={`relative ${selectedTabprojectapproved
                          ? "bg-yellow-600 border-[#3a1e0a] shadow-lg"
                          : "bg-[#ffc000] border-[#5A3D2B]"
                        } border-[#5A3D2B] flex items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer 
                          
                          `}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadcountapproved.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            
                            <span

                              className="  opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                            >
                              {unreadcountapproved.length}
                            </span>
                          </div>
                        )}

                        

                        <span className={`text-white ${unreadcountapproved.length > 0 ? "text-2xl font-semibold" : "text-lg"} `}>{approvedProjectsManager?.length}</span>
                        {selectedTabprojectapproved && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[450px] w-[20%] items-center"
                      onMouseEnter={() => setHoveredAssignmentBucket("projectAssigned")}
                      onMouseLeave={() => setHoveredAssignmentBucket("")}
                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Assigned
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          setselectedTabState("projectAssigned")
                          setselectedTabprojectrequest(false)
                          setselectedTabprojectapproved(false)
                          setselectedTabprojectassign(!selectedTabprojectassign)
                          setselectedTabprojectongoing(false)
                          setselectedTabprojectcomplete(false)
                        }}
                        
                        className={`relative flex ${selectedTabprojectassign
                          ? "bg-yellow-800 border-[#3a1e0a] shadow-lg"
                          : "bg-[#cfb053] border-[#5A3D2B]"
                        } border-[#5A3D2B] items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer 
                          
                          `}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadcountAssign.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            
                            <span

                              className="opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                            >
                              {unreadcountAssign.length}
                            </span>
                          </div>
                        )}
                        
                        <span className={`text-white ${unreadcountAssign.length > 0 ? "text-2xl font-semibold" : "text-lg"}`}>
                          {assignedOpProjects.length}
                        </span>
                        {selectedTabprojectassign && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex gap-1 h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[450px] w-[20%] items-center"
                      onMouseEnter={() => setHoveredAssignmentBucket("projectOngoing")}
                      onMouseLeave={() => setHoveredAssignmentBucket("")}
                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Ongoing
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          setselectedTabState("projectOngoing")
                          setselectedTabprojectrequest(false)
                          setselectedTabprojectapproved(false)
                          setselectedTabprojectassign(false)
                          setselectedTabprojectongoing(!selectedTabprojectongoing)
                          setselectedTabprojectcomplete(false)
                        }}
                        
                        className={`relative flex ${selectedTabprojectongoing
                          ? "bg-[#D27D2D] border-[#3a1e0a] shadow-lg"
                          : "bg-yellow-700 border-[#5A3D2B]"
                        } border-[#5A3D2B] items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer 
                         
                          `}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadcountongoing.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            
                            <span

                              className="opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                            >
                              {unreadcountongoing.length}
                            </span>
                          </div>
                        )}
                        
                        <span className={`text-white ${unreadcountongoing.length > 0 ? " text-2xl font-semibold" : "text-lg"}`}>
                          {ongoingOpProjects.length}
                        </span>
                        {selectedTabprojectongoing && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                    <div
                      className="flex h-[240px] lg:h-[265px] xl:h-[275px] td:h-[360px]  cp:h-[450px] w-[20%] items-center"
                      onMouseEnter={() => setHoveredAssignmentBucket("projectCompleted")}
                      onMouseLeave={() => setHoveredAssignmentBucket("")}
                    >
                      <div className="w-[20%] flex justify-center">
                        <p className="-rotate-90 text-black text-md font-semibold whitespace-nowrap">
                          Project Completed
                        </p>
                      </div>

                      <div
                        onClick={() => {
                          setselectedTabState("projectCompleted")
                          setselectedTabprojectrequest(false)
                          setselectedTabprojectapproved(false)
                          setselectedTabprojectassign(false)
                          setselectedTabprojectongoing(false)
                          setselectedTabprojectcomplete(!selectedTabprojectcomplete)
                        }}
                        
                        className={`relative flex ${selectedTabprojectcomplete
                          ? "bg-green-600 border-[#3a1e0a] shadow-lg"
                          : "bg-[#47d45a] border-[#5A3D2B]"
                        } border-[#5A3D2B] items-center justify-center w-[80%] h-full rounded-2xl border-2 cursor-pointer
                           
                          `}
                        style={{ borderColor: "#5A3D2B" }}
                      >
                        {unreadcountcomplete.length > 0 && (
                          <div className="absolute top-3 flex justify-center align-middle items-center">
                            
                            <span

                              className=" opacity-90 bg-red-600 text-white text-xs font-bold px-1.5 py-0.5 rounded-full"
                            >
                              {unreadcountcomplete.length}
                            </span>
                          </div>
                        )}
                        
                        <span className={`text-white ${unreadcountcomplete.length > 0 ? " text-2xl font-semibold" : "text-lg"}`}>
                          {completeOpProjects.length}
                        </span>
                        {selectedTabprojectcomplete && (
                          <ExpandMoreIcon className="absolute bottom-1 text-white cursor-pointer" />
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="mx-2 mb-2 min-h-[58px]">
                    {hoveredAssignmentBucket && (
                      <div className="border border-gray-500 bg-[#f2f2f2] px-3 py-2 text-center text-[15px] font-medium text-black rounded-sm">
                        {assignmentHoverTextMap[hoveredAssignmentBucket]}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  )
}

export default MyManagementDash
